import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NgxPermissionsGuard } from "ngx-permissions";
import { MedalsComponent } from "./medals/medals.component";
import { AuthGuardService as AuthGuard } from "../auth/auth-guard.service";
import { ScheduleSportComponent } from "./schedule-sport/schedule-sport.component";
import { ScheduleUserComponent } from "./schedule-user/schedule-user.component";
import { ScheduleComponent } from "./schedule/schedule.component";
import { SummaryUserComponent } from "./summary-user/summary-user.component";
import { SummarySportComponent } from "./summary-sport/summary-sport.component";
import { ScheduleSportDetailComponent } from "./schedule-sport-detail/schedule-sport-detail.component";
import { ScheduleSportOverviewComponent } from "./schedule-sport-overview/schedule-sport-overview.component";
import { AddScheduleComponent } from "./add-schedule/add-schedule.component";
import { EditScheduleComponent } from "./edit-schedule/edit-schedule.component";
import { PublicViewComponent } from "./public-view/public-view.component";
import { SummarySportListComponent } from "./summary-sport-list/summary-sport-list.component";
import { SummaryCategoryListComponent } from "./summary-category-list/summary-category-list.component";
import { SummaryFixtureListComponent } from "./summary-fixture-list/summary-fixture-list.component";
import { SummaryFixtureAddComponent } from "./summary-fixture-add/summary-fixture-add.component";
import { ResultSportsComponent } from "./result-sports/result-sports.component";
import { ResultCategoryComponent } from "./result-category/result-category.component";
import { ResultFixtureComponent } from "./result-fixture/result-fixture.component";
import { PublicMedalComponent } from "./public-medal/public-medal.component";
import { PublicResultComponent } from "./public-result/public-result.component";
import { PubilcUserResultComponent } from "./pubilc-user-result/pubilc-user-result.component";
import { SummaryFixtureListDetailComponent } from "./summary-fixture-list-detail/summary-fixture-list-detail.component";
import { PublicSportComponent } from "./public-sport/public-sport.component";
import { PublicSportCategoryComponent } from "./public-sport-category/public-sport-category.component";
import { PublicSportCategoryFixtureComponent } from "./public-sport-category-fixture/public-sport-category-fixture.component";
import { PublicSportHighlightComponent } from "./public-sport-highlight/public-sport-highlight.component";
import { SportFixturesComponent } from "./sport-fixtures/sport-fixtures.component";

const routes: Routes = [
    {
        path: "",
        component: MedalsComponent,
    },
    {
        path: "sport-highlight",
        component: PublicSportHighlightComponent,
    },
    {
        path: "public",
        component: PublicViewComponent,
    },
    {
        path: "schedule-sport",
        component: ScheduleSportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: ["ADMIN", "EDITOR"],
                redirectTo: "/404",
            },
        },
    },
    {
        path: "schedule-user",
        component: ScheduleUserComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: "ADMIN",
                redirectTo: "/404",
            },
        },
    },
    {
        path: "schedule",
        component: ScheduleComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: "ADMIN",
                redirectTo: "/404",
            },
        },
    },
    {
        path: "add",
        component: AddScheduleComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: ["ADMIN", "EDITOR"],
                redirectTo: "/404",
            },
        },
    },
    {
        path: "edit/:id",
        component: EditScheduleComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: ["ADMIN", "EDITOR"],
                redirectTo: "/404",
            },
        },
    },
    {
        path: "summary-user",
        component: SummaryUserComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: "ADMIN",
                redirectTo: "/404",
            },
        },
    },
    {
        path: "summary-sport",
        component: SummarySportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: "ADMIN",
                redirectTo: "/404",
            },
        },
    },
    {
        path: "schedule-sport-detail/:id",
        component: ScheduleSportDetailComponent,
        canActivate: [NgxPermissionsGuard],
        // data: {
        //     permissions: {
        //         only: "ADMIN",
        //         redirectTo: "/404",
        //     },
        // },
    },
    {
        path: "schedule-sport-overview/:sportId/:id/:name",
        component: ScheduleSportOverviewComponent,
        canActivate: [NgxPermissionsGuard],
        // data: {
        //     permissions: {
        //         only: "ADMIN",
        //         redirectTo: "/404",
        //     },
        // },
    },
    {
        path: "sports-fixture/:sportId",
        component: SportFixturesComponent,
        canActivate: [NgxPermissionsGuard],
        // data: {
        //     permissions: {
        //         only: ["ADMIN", "EDITOR"],
        //         redirectTo: "/404",
        //     },
        // },
    },
    {
        path: "fixture-sports",
        component: SummarySportListComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: ["ADMIN", "EDITOR"],
                redirectTo: "/404",
            },
        },
    },
    {
        path: "fixture-category/:id",
        component: SummaryCategoryListComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: ["ADMIN", "EDITOR"],
                redirectTo: "/404",
            },
        },
    },
    {
        path: "fixture-list/:sportId/:id/:name",
        component: SummaryFixtureListComponent,
    },
    {
        path: "fixture-score/:id",
        component: SummaryFixtureAddComponent,
    },
    {
        path: "result-sport",
        component: ResultSportsComponent,
    },
    {
        path: "result-category/:id",
        component: ResultCategoryComponent,
    },
    {
        path: "result-fixture/:sportId/:id/:name",
        component: ResultFixtureComponent,
    },
    {
        path: "result-all-fixture",
        component: PublicResultComponent,
    },
    {
        path: "public-medal",
        component: PublicMedalComponent,
    },
    {
        path: "public-user-result/:id",
        component: PubilcUserResultComponent,
    },
    {
        path: "public-sport",
        component: PublicSportComponent,
    },
    {
        path: "public-sport/:id",
        component: PublicSportCategoryComponent,
    },
    {
        path: "public-sport-category-fixture/:id",
        component: PublicSportCategoryFixtureComponent,
    },
    {
        path: "fixture-detail/:id",
        component: SummaryFixtureListDetailComponent,
    },
    { path: "500", redirectTo: "/500" },
    { path: "401", redirectTo: "/402" },
    { path: "404", redirectTo: "/404" },
    { path: "", redirectTo: "/404" },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ReportsRoutingModule {}
